// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2mamt","item":"PaymentsMobile_item__Bq840","label":"PaymentsMobile_label__1Qr56","amount":"PaymentsMobile_amount__OQQZL"};